module.exports = __webpack_public_path__ + "static/media/greenedit.56da296f.svg";